module.exports = __webpack_public_path__ + "img/progress-bar-icon.fbd2404f.svg";